const $inject = ['$rootScope', 'beamerService'];

const lbBeamerCtrl = function ($rootScope, beamerService) {
  let $ctrl = this;
  $ctrl.show = false;
  $ctrl.url = beamerService.getUrl();

  $ctrl.close = function () {
    $ctrl.show = false;
  };

  $rootScope.$on('openBeamer', function (event, data) {
    $ctrl.show = true;
  });

  window.addEventListener(
    'message',
    (event) => {
      if (event.origin !== 'https://app.getbeamer.com') return;
      let data = {};

      let action = event.data;

      if (!action && action.includes(':')) return;

      action = event.data.split(':')[0];

      if (action === 'hide') {
        $ctrl.close();
        $rootScope.$apply();
        return;
      }

      const dataString = event.data.split(':').slice(1).join(':');

      data = JSON.parse(dataString);

      if (action === 'showPicture') {
        showPicture(data.url);
      }
    },
    false
  );

  function showPicture(a) {
    hidePicture();
    var b = $('<div>').attr('id', 'beamerPicture').attr('class', 'hideable').click(hidePicture),
      c = $('<div>').attr('class', 'iframeCointaner');
    a = $('<img>').attr('src', a);
    c.append(a);
    b.append(c);
    $('body').append(b);
    setTimeout(function () {
      b.addClass('visible');
    }, 10);
  }
  function hidePicture() {
    var a = $('#beamerPicture');
    a &&
      (a.removeClass('visible'),
      setTimeout(function () {
        a.remove();
      }, 250));
  }
};

lbBeamerCtrl.$inject = $inject;

export default lbBeamerCtrl;



// WEBPACK FOOTER //
// ./src/components/lbBeamer/lbBeamerCtrl.js